/**
 * @generated SignedSource<<a70afa64278b2117029dbf026a9c967a>>
 * @relayHash 74a2c2b66d4403117afe9dd5ff37eb63
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

// @relayRequestID 74a2c2b66d4403117afe9dd5ff37eb63

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ccnId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contractId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sirets"
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "ccnId",
        "variableName": "ccnId"
      },
      {
        "kind": "Variable",
        "name": "contractId",
        "variableName": "contractId"
      },
      {
        "kind": "Variable",
        "name": "sirets",
        "variableName": "sirets"
      }
    ],
    "concreteType": "SiretIsUsed",
    "kind": "LinkedField",
    "name": "siretsAreUsed",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "siret",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isUsed",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "useCheckSiretsAreUsedQuery",
    "selections": (v3/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "useCheckSiretsAreUsedQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "id": "74a2c2b66d4403117afe9dd5ff37eb63",
    "metadata": {},
    "name": "useCheckSiretsAreUsedQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

node.hash = "95358c2e5622b7ef95b633d59bf338c6";

export default node;
